import styled from 'styled-components';
import Check from '@catalogo/ui-americanas-desktop-svg/check.svg';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px 0 90px 0;
`;

const FeedbackTitle = styled.b`
  margin-top: 15px;
  font-size: 18px;
  line-height: 19.2px;
  color: #333333;
  padding-bottom: 10px;
  text-transform: ${({ theme }) => theme.titleTransform};
`;

const Subtitle = styled.p`
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
  text-transform: none;
`;

const CheckIcon = styled(Check)`
  width: 60px;
  height: 60px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: rgb(64, 205, 40);
  fill: #fff;
  border-radius: 50%;
  align-self: center;
  padding: 13px;
  margin-bottom: 10px;
`;

export { Container, FeedbackTitle, Subtitle, CheckIcon };
